import React from 'react';
import classNames from 'classnames';
import { Icon } from 'js/components';

import styles from './OrgNodePicker.module.scss';

function OrgNodeRowIcon({ row, ...props }) {
  if (row.type === 'team') {
    return <Icon className="row-icon team-icon" icon="users" {...props} />;
  }

  if (row.isRoot) {
    return <Icon className="row-icon org-icon" icon="sitemap" {...props} />;
  }

  return (
    <Icon
      className="row-icon folder-icon"
      icon="user-friends"
      mask="folder"
      transform="shrink-9 down-1"
      {...props}
    />
  );
}

function OrgNodePickerSearchRow({
  row,
  highlighted = false,
  selected = false,
  itemProps = {},
}) {
  return (
    <li
      className={classNames('combobox-item', styles['search-item'], {
        highlighted,
        selected,
      })}
      {...itemProps}
    >
      <div className={styles['search-item-icon']}>
        <OrgNodeRowIcon row={row} fixedWidth />
      </div>
      <div className={styles['search-item-text']}>
        <div className={styles['search-item-name']}>{row.name}</div>
        <div className={styles['search-item-breadcrumb']}>{row.breadcrumb}</div>
      </div>
    </li>
  );
}

function OrgNodePickerTreeRow({
  row,
  highlighted = false,
  selected = false,
  itemProps = {},
}) {
  return (
    <li
      className={classNames('combobox-item', styles['tree-item'], {
        highlighted,
        selected,
      })}
      {...itemProps}
    >
      <div className={classNames('row', styles['tree-row'])}>
        <div className="gutters">
          {row.pathToNode.map((segment) => (
            <div
              key={segment.pathKey}
              className={classNames('gutter', {
                'org-level': segment.isRoot,
                'group-level': !segment.isRoot,
              })}
            />
          ))}
        </div>
        <div className="icons">
          <OrgNodeRowIcon row={row} />
        </div>
        <div className="row-content">
          <div className="name">{row.name}</div>
        </div>
      </div>
    </li>
  );
}

function OrgNodePickerRow({ mode = 'tree', ...props }) {
  return mode === 'search' ? (
    <OrgNodePickerSearchRow {...props} />
  ) : (
    <OrgNodePickerTreeRow {...props} />
  );
}

export default OrgNodePickerRow;
